module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "picker"
    }
  }, [_c('touch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "picker-backdrop",
    on: {
      "tap": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "picker-wrapper"
  }, [_c('div', {
    staticClass: "picker-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "picker-content"
  }, [_c('div', {
    staticClass: "picker-body"
  }, _vm._l((_vm.dataItems), function(item, index) {
    return _c('picker-item', {
      style: (item.style),
      attrs: {
        "itemIndex": index,
        "index": item.index,
        "all-values": item.values,
        "values": item.$value,
        "length": item.values.length - 1,
        "maxScrollValue": item.maxScrollValue,
        "keyName": item.key
      },
      on: {
        "change": _vm.onChangeValue
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "picker-helper"
  })]), _vm._v(" "), _c('div', {
    staticClass: "picker-footer"
  }, [_vm._t("footer")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4fd7a18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/picker.vue
// module id = 372
// module chunks = 1